import { toast } from "sonner";

// Reazione visiva uniforme per bottoni, menu, caselle e interruttori che salvano qualcosa (esclusi i "Salva", gestiti da salvataggio.js).
const RX_SALVA_TESTO = /^\s*salva(\s|$)/i;
const RX_SALVA_ID = /(^|-)(save|salva)(-|$)/i;
const SEL = "button,[role=button],[role=switch],[role=checkbox],[role=menuitem],select,input[type=checkbox],input[type=radio]";
let pending = null;

const isSalva = (b) => b.tagName === "BUTTON" && (RX_SALVA_TESTO.test(b.textContent || "") || RX_SALVA_ID.test(b.getAttribute("data-testid") || ""));
const nToast = () => document.querySelectorAll("[data-sonner-toast]").length;

function overlay(el) {
  return el.closest(".fixed.inset-0,[role=dialog],[role=alertdialog],[role=menu]");
}

function chiusuraAnimata(p) {
  if (!p.box || p.box.isConnected || !p.clone) return;
  const c = p.clone;
  c.classList.add("chiusura-animata");
  document.body.appendChild(c);
  setTimeout(() => c.remove(), 220);
}

function fine(p, ok) {
  if (pending === p) pending = null;
  const el = p.el;
  if (el.isConnected) {
    delete el.dataset.lavora;
    el.dataset.esito = ok ? "ok" : "err";
    setTimeout(() => { delete el.dataset.esito; }, 1200);
  }
  if (!ok) return;
  chiusuraAnimata(p);
  setTimeout(() => { if (ultimoToast < p.t) toast.success(p.box && !p.box.isConnected ? "Fatto" : "Aggiornato", { id: "feedback-azione", duration: 2200 }); }, 450);
}

let ultimoToast = 0;
["success", "error", "message", "info", "warning"].forEach((k) => {
  const orig = toast[k];
  if (typeof orig === "function") toast[k] = (msg, o) => { if (o?.id !== "feedback-azione") ultimoToast = Date.now(); return orig(msg, o); };
});

export function installaFeedback(api) {
  const arma = (e) => {
    const el = e.target.closest?.(SEL);
    if (!el || el.closest("[data-no-feedback]") || isSalva(el)) return;
    const box = overlay(el);
    pending = { el, t: Date.now(), reqs: 0, ok: true, timer: null, box, clone: null, toasts: nToast() };
  };
  document.addEventListener("click", arma, true);
  document.addEventListener("change", arma, true);

  document.addEventListener("mouseover", (e) => {
    const b = e.target.closest?.("button:disabled");
    if (b && !b.title && !b.dataset.lavora) b.title = "Non disponibile: non hai il permesso oppure mancano dati obbligatori";
  }, true);

  api.interceptors.request.use((config) => {
    const m = (config.method || "get").toLowerCase();
    const p = pending;
    if (p && !config._salva && m !== "get" && (p.reqs > 0 || p.timer || Date.now() - p.t < 1500)) {
      config._feedback = p;
      clearTimeout(p.timer); p.timer = null;
      p.reqs += 1;
      if (p.el.isConnected) p.el.dataset.lavora = "1";
      if (p.box && !p.clone) {
        const c = p.box.cloneNode(true);
        c.removeAttribute("data-testid");
        c.querySelectorAll("[data-testid]").forEach((x) => x.removeAttribute("data-testid"));
        c.querySelectorAll("[data-lavora]").forEach((x) => delete x.dataset.lavora);
        c.style.pointerEvents = "none";
        c.setAttribute("aria-hidden", "true");
        p.clone = c;
      }
    }
    return config;
  });
  const chiudi = (cfg, ok) => {
    const p = cfg?._feedback;
    if (!p) return;
    p.reqs -= 1;
    if (!ok) p.ok = false;
    if (p.reqs <= 0) p.timer = setTimeout(() => fine(p, p.ok), 200);
  };
  api.interceptors.response.use((r) => { chiudi(r.config, true); return r; }, (err) => { chiudi(err?.config, false); return Promise.reject(err); });
}
